const toArray = (value) =>
  Array.isArray(value) ? value.filter(Boolean) : value ? [value] : [];

export const getSwapRequestWrestlerIds = (requestItem, side) => {
  const multiValue = toArray(requestItem?.[`${side}WrestlerIds`]);
  if (multiValue.length > 0) {
    return [...new Set(multiValue)];
  }

  const legacyValue = requestItem?.[`${side}WrestlerId`];
  return legacyValue ? [legacyValue] : [];
};

export const getSwapRequestWrestlerNames = (
  requestItem,
  side,
  wrestlerNames = {}
) => {
  const ids = getSwapRequestWrestlerIds(requestItem, side);
  const explicitNames = toArray(requestItem?.[`${side}WrestlerNames`]);
  const legacyName = requestItem?.[`${side}WrestlerName`] || '';

  return ids.map(
    (id, index) =>
      explicitNames[index] ||
      (index === 0 ? legacyName : '') ||
      wrestlerNames[id] ||
      'Wrestler sconosciuto'
  );
};

export const getSwapRequestAllWrestlerIds = (requestItem) => [
  ...getSwapRequestWrestlerIds(requestItem, 'requester'),
  ...getSwapRequestWrestlerIds(requestItem, 'target'),
];

export const buildSwapRequestPairings = (
  requestItem,
  wrestlerNames = {}
) => {
  const requesterIds = getSwapRequestWrestlerIds(requestItem, 'requester');
  const requesterNames = getSwapRequestWrestlerNames(
    requestItem,
    'requester',
    wrestlerNames
  );
  const targetIds = getSwapRequestWrestlerIds(requestItem, 'target');
  const targetNames = getSwapRequestWrestlerNames(
    requestItem,
    'target',
    wrestlerNames
  );
  const pairCount = Math.max(requesterIds.length, targetIds.length);

  return Array.from({ length: pairCount }, (_, index) => ({
    requesterId: requesterIds[index] || null,
    requesterName: requesterNames[index] || 'Wrestler sconosciuto',
    targetId: targetIds[index] || null,
    targetName: targetNames[index] || 'Wrestler sconosciuto',
  }));
};

export const getSwapRequestPreviewLabel = (
  requestItem,
  side,
  wrestlerNames = {},
  maxVisible = 2
) => {
  const names = getSwapRequestWrestlerNames(requestItem, side, wrestlerNames);

  if (names.length === 0) return 'Nessun wrestler';
  if (names.length <= maxVisible) return names.join(', ');

  return `${names.slice(0, maxVisible).join(', ')} +${names.length - maxVisible}`;
};
